import React from "react"
import {Route} from "react-router-dom"


function RouteWithLayout({layout, component, footer, ...rest}) {
  return (
    <Route {...rest} render={(props) =>
      React.createElement(layout, props
        , React.createElement(component, props)
        , footer ? React.createElement(footer, props) : null
      )
    }/>
  );
}

export default RouteWithLayout



// WEBPACK FOOTER //
// ./src/theme/moderntimes/layout/RouteWithLayout.js